export default "__VITE_ASSET__DBlIexy0__"